/** English mirror for unified landing strings */
export const landingUnifiedEn = {
  solutions: {
    detail: {
      team_cta: 'Make your team unstoppable',
    },
  },
};
